<template>
  <component
    :is="href !== undefined ? 'a' : 'button'"
    :href="href"
    :target="target"
    :rel="rel"
    :disabled="disabled"
    class="flex items-center justify-center font-sans border-t border-[internal] shrink-0 disabled:bg-fill-disabled disabled:border-transparent disabled:text-basics-secondary-80"
    :class="{
      'rounded-full': !rounded,
      'rounded-sm': rounded === 'sm',
      'rounded-md': rounded === 'md',
      'rounded-lg': rounded === 'lg',

      'hover:bg-brand-tertiary-60 hover:border-basics-quaternary-40 active:border-brand-light-bg-overlay-50':
        variant !== 'danger',

      'bg-surface border-transparent text-text': variant === 'subtle',
      'bg-transparent border-transparent text-basics-primary':
        variant === 'ghost',
      'bg-brand-primary text-basics-primary':
        variant === 'primary' || variant === 'square',
      'bg-basics-accent-red text-basics-primary border-t-basics-quaternary-40 hover:bg-opacity-75 hover:border-basics-secondary-80 active:border-brand-light-bg-overlay-50':
        variant === 'danger',
      'border border-brand-primary bg-transparent text-basics-primary':
        variant === 'outline',
      'bg-fill-warning hover:bg-fill-warning border-transparent text-text':
        variant === 'warning',

      'text-xl': size === 'xs',
      'text-sm leading-5': size === 'sm' || size === 'md',
      'text-base font-normal leading-5 font-serif': size === 'lg',

      'aspect-square': variant === 'square',
      'size-7': variant === 'square' && size === 'xs',
      'size-8': variant === 'square' && size === 'sm',
      'size-10': variant === 'square' && size === 'md',
      'size-50u': variant === 'square' && size === 'lg',

      'p-1': variant !== 'square' && size === 'xs',
      'px-4 py-2 min-h-8': variant !== 'square' && size === 'sm',
      'px-2 py-2 min-h-10': variant !== 'square' && size === 'md',
      'px-6 py-2 min-h-50u': variant !== 'square' && size === 'lg',
    }"
  >
    <span v-if="isLoading" class="loading loading-spinner loading-md" />
    <slot></slot>
  </component>
</template>

<script lang="ts" setup>
defineProps<{
  variant:
    | "primary"
    | "danger"
    | "outline"
    | "subtle"
    | "ghost"
    | "square"
    | "warning";
  size: "xs" | "sm" | "lg" | "md";
  href?: string;
  target?: string;
  disabled?: boolean;
  isLoading?: boolean;
  rel?: string;
  rounded?: "full" | "sm" | "md" | "lg";
}>();
</script>
